export default class UserAgentCheck {
    static isApp(userAgent) {
        return new RegExp("^bonprix( mobile)? App ", "i").test(userAgent);
    }

    static isAndroidApp(userAgent) {
        return userAgent.toLowerCase().includes("android") && this.isApp(userAgent);
    }

    static isIOsApp(userAgent) {
        return (userAgent.toLowerCase().includes("ipad") || userAgent.toLowerCase().includes("iphone") || userAgent.toLowerCase().includes("ios") ) && this.isApp(userAgent);
    }

    /**
     * Extracts app version from user agent string.
     * Matches pattern: "bonprix mobile App 1.38 (...)"
     *
     * @param {string} userAgent - User agent string
     * @returns {string|null} Version string (e.g. "1.38") or null if not found
     */
    static getAppVersion(userAgent) {
        if (!this.isApp(userAgent)) {
            return null;
        }

        const versionPattern = /^bonprix( mobile)? App ([\d.]+) /i;
        const match = userAgent.match(versionPattern);

        return match ? match[2] : null;
    }

    /**
     * Compares two version strings.
     *
     * @param {string} version1 - First version (e.g. "1.38")
     * @param {string} version2 - Second version (e.g. "1.40")
     * @returns {number} -1 if version1 < version2, 0 if equal, 1 if version1 > version2
     */
    static compareVersions(version1, version2) {
        const v1Parts = version1.split('.').map(Number);
        const v2Parts = version2.split('.').map(Number);
        const maxLength = Math.max(v1Parts.length, v2Parts.length);

        for (let i = 0; i < maxLength; i++) {
            const v1Part = v1Parts[i] || 0;
            const v2Part = v2Parts[i] || 0;

            if (v1Part > v2Part) return 1;
            if (v1Part < v2Part) return -1;
        }

        return 0;
    }

    /**
     * Checks if app version supports cookie banner based on minimum required version.
     * Replicates Java UserAgentHelper.appVersionSupportsCookieBanner()
     *
     * @param {string} userAgent - User agent string
     * @param {string} minVersion - Minimum required version (e.g. "1.38")
     * @returns {boolean} true if app version >= minVersion
     */
    static appVersionSupportsCookieBanner(userAgent, minVersion) {
        if (!minVersion || !this.isApp(userAgent)) {
            return false;
        }

        const appVersion = this.getAppVersion(userAgent);
        if (!appVersion) {
            return false;
        }

        return this.compareVersions(appVersion, minVersion) >= 0;
    }
}
//# sourceMappingURL=UserAgentCheck.js.map